import { useCallback, useEffect, useState } from 'react';
import { useInventoryAppServices } from '@/app/services/InventoryAppServicesContext';
import { getStorageHealth, type StorageHealth } from '@/shared/db/storage-health';

interface StorageHealthState {
  storageHealth: StorageHealth | null;
  isLoading: boolean;
  error: string | null;
}

export function useStorageHealth(input: { locationId?: number | string } = {}) {
  const { database } = useInventoryAppServices();
  const [state, setState] = useState<StorageHealthState>({
    storageHealth: null,
    isLoading: true,
    error: null,
  });

  const load = useCallback(async () => {
    setState(current => ({ ...current, isLoading: true, error: null }));

    try {
      const storageHealth = await getStorageHealth(database, { locationId: input.locationId });
      setState({ storageHealth, isLoading: false, error: null });
    } catch (error) {
      setState({
        storageHealth: null,
        isLoading: false,
        error: error instanceof Error ? error.message : 'Unable to load storage health.',
      });
    }
  }, [database, input.locationId]);

  useEffect(() => {
    void load();
  }, [load]);

  return {
    ...state,
    refresh: load,
  };
}
